import React, { PropsWithChildren } from "react";

import "./orientation-blocker.css";

export const OrientationBlocker = ({ children }: PropsWithChildren) => (
	<div className="orientation-blocker">{children}</div>
);
OrientationBlocker.displayName = "OrientationBlocker";
